const DownloadFile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.5 11.5V13.2C1.5 13.918 2.08203 14.5 2.8 14.5H8H13.2C13.918 14.5 14.5 13.918 14.5 13.2V11.5"
        stroke="white"
        stroke-width="1.33"
        stroke-linecap="round"
      />
      <path
        d="M7.73317 11.2C7.76422 11.2414 7.80448 11.275 7.85077 11.2981C7.89705 11.3213 7.94809 11.3333 7.99984 11.3333C8.05159 11.3333 8.10262 11.3213 8.14891 11.2981C8.19519 11.275 8.23545 11.2414 8.2665 11.2L11.2665 7.2C11.3036 7.15048 11.3263 7.09159 11.3318 7.02994C11.3374 6.96828 11.3257 6.9063 11.298 6.85093C11.2703 6.79556 11.2277 6.74899 11.1751 6.71645C11.1224 6.68391 11.0617 6.66667 10.9998 6.66667H8.6665V1.66667C8.6665 1.48986 8.59627 1.32029 8.47124 1.19526C8.34622 1.07024 8.17665 1 7.99984 1C7.82303 1 7.65346 1.07024 7.52843 1.19526C7.40341 1.32029 7.33317 1.48986 7.33317 1.66667V6.66667H4.99984C4.93793 6.66667 4.87725 6.68391 4.82459 6.71645C4.77194 6.74899 4.72938 6.79556 4.70169 6.85093C4.67401 6.9063 4.66229 6.96828 4.66785 7.02994C4.67341 7.09159 4.69603 7.15048 4.73317 7.2L7.73317 11.2Z"
        fill="white"
      />
    </svg>
  )
}

export default DownloadFile
